import {mapStyles} from "./map-styles";

export class Map {
    constructor(storeMapNode) {
        let storesContainer = document.querySelector('.data-stores');
        if(storesContainer && storesContainer.dataset.stores) {
            this.locations = JSON.parse(storesContainer.dataset.stores);
        }
        this.$storeMap = storeMapNode;
        this.$storeList = document.querySelector('.store_list_wrapper');
        this.map = {};
        this.markers = [];
    }

    init() {
        this.addMapOverlays();
        this.renderMap();
        this.addMarkers();

        if(window.innerWidth < 641) {
            this.$storeMap.classList.add('mobile-map');

            if(!this.$storeList) {
                this.$storeMap.classList.add('show-map');
            }
        }

        window.addEventListener('resize', ()=> {
            requestAnimationFrame(()=> {
                if(window.innerWidth < 641) {
                    this.$storeMap.classList.add('mobile-map');

                    if(!this.$storeList) {
                        this.$storeMap.classList.add('show-map');
                    }
                } else {
                    this.$storeMap.classList.remove('mobile-map');
                    this.$storeMap.classList.remove('show-map');
                }
            });
        });
    }

    addMapOverlays() {
        this.$storeMap.insertAdjacentHTML('beforeend',
            `<div class="inset-shadow"></div>`
        );

        // If the current page lists all stores, then add a white overlay below the map
        if (this.$storeList) {
            this.$storeMap.insertAdjacentHTML('beforeend',
                `<div class="hue"></div>`
            );

            let hue = document.querySelector('.hue');

            window.addEventListener('scroll', ()=> {
                requestAnimationFrame(()=> {
                    if (pageYOffset >= 5) {
                        hue.style.visibility = 'visible';
                        hue.style.opacity = '1';
                    } else {
                        hue.style.visibility = 'hidden';
                        hue.style.opacity = '0';
                    }
                })
            });
        }
    }

    addMarkers() {
        let storesContainer = document.querySelector('.data-stores');
        if(storesContainer) {
            this.markerSvg = storesContainer.dataset.svgpath;
        }

        let bounds = new google.maps.LatLngBounds();

        let mapObject = this.map;
        let infoWindow = new google.maps.InfoWindow({});
        this.locations && this.locations.forEach((location)=> {
            let content = `
                <div class="infobox">
                    <div class="infobox_address">
                        <strong>${decodeURIComponent(location.name)}</strong><br />
                        ${decodeURIComponent(location.street)}<br />
                        ${decodeURIComponent(location.postalcode)} ${decodeURIComponent(location.city)}<br />
                    </div>
                    <div class="infobox_contact">
                        T ${decodeURIComponent(location.phone_number)}
                    </div>
                </div>`;

            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(location.latitude, location.longitude),
                map: this.map,
                title: decodeURIComponent(location.name),
                icon: this.markerSvg,
                id: location.name
            });

            marker.addListener('click', (e)=> {
                infoWindow.setContent(content);
                infoWindow.open(mapObject, marker);
            });

            //extend the bounds to include each marker's position
            bounds.extend(marker.position);
            this.markers.push(marker);

        });

        this.map.addListener('click', ()=>{infoWindow.close();});
        if (this.markers.length > 1) {
            this.map.fitBounds(bounds);
        } else {
            this.map.setCenter(this.markers[0].position)
        }

    }

    renderMap() {
        this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 12,
            styles: mapStyles,
            disableDefaultUI: true
        });
    }
}
